import React, { useEffect, useState } from 'react';
import { MainApp } from './MainApp';
import { LoginScreen, UnauthorizedScreen, AccessCheckFailedScreen } from './auth/LoginScreen';
import { Spinner } from './components/base';
import { auth, getUserDoc } from './lib/firebase';
import { PartnerPortalApp } from './portal/PartnerPortal';
import { ReferralFormApp } from './portal/ReferralFormApp';

function App() {
  // Se URL tiver ?portal=TOKEN, mostrar portal do parceiro direto (sem login)
  const portalToken = new URLSearchParams(window.location.search).get('portal');
  if (portalToken) return <PartnerPortalApp token={portalToken} />;

  // Se URL tiver ?indicar=EMPRESA_ID, mostrar formulário público de indicação (sem login)
  const indicarId = new URLSearchParams(window.location.search).get('indicar');
  if (indicarId) return <ReferralFormApp companyId={indicarId} />;

  const [user, setUser]         = useState(null);
  const [userDoc, setUserDoc]   = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  const verificarAcesso = async (u) => {
    setAuthLoading(true);
    setUserDoc(await getUserDoc(u.email));
    setAuthLoading(false);
  };

  useEffect(() => {
    return auth.onAuthStateChanged(async (u) => {
      setUser(u);
      if (u) {
        const doc = await getUserDoc(u.email);
        setUserDoc(doc);
      } else {
        setUserDoc(null);
      }
      setAuthLoading(false);
    });
  }, []);

  if (authLoading) return <div className="min-h-screen bg-gray-100 flex items-center justify-center"><Spinner /></div>;
  if (!user) return <LoginScreen />;
  if (userDoc?.erro) return <AccessCheckFailedScreen user={user} erro={userDoc.erro} onRetry={() => verificarAcesso(user)} />;
  if (!userDoc) return <UnauthorizedScreen user={user} />;
  return <MainApp user={user} userDoc={userDoc} />;
}

export { App };
